import { ClickAwayListener } from '@mui/material';
import { closeSnackbar, SnackbarContent, CustomContentProps } from 'notistack';
import { forwardRef, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

import { BonusImage, BonusText, Container } from './styled';
import { launchGame, userSelector } from 'features/user';

interface SnackbarProps extends CustomContentProps {
    data: any,
    playingGameId: number | null,
};

const bonusGames = {
    '401': 'Lucky Lady Charm Deluxe',
    '402': 'Blood Suckers',
    '403': 'Wizard of Oz',
    '404': 'Excalibur',
};

const BonusSnackbar = forwardRef<HTMLDivElement, SnackbarProps>((props, ref) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { playingGameId } = useSelector(userSelector);

    const {
        data,
        id,
        style,
    } = props;

    const freeSpinsGameName = bonusGames[data.gamePermit] || data.gamePermit;
    const imageId = useRef(Math.floor(Math.random() * 4) + 1);

    const onClick = () => {
        closeSnackbar(id);
        if (playingGameId) {
            return;
        }
        // @ts-ignore
        dispatch(launchGame({ gameId: data.gamePermit }));
    }

    if (data.freespinsLeft > 0) {
        return (
            <ClickAwayListener onClickAway={() => closeSnackbar(id)}>
                <SnackbarContent ref={ref} style={style} onClick={onClick}>
                    <Container>
                        <BonusImage alt="Bonus" src={require(`./img/${`bonus${imageId.current}_bg.png`}`)} />
                        <BonusText>
                            {t(`bonus.freeSpinsBonus`, {
                                freeSpins: data.freespinsLeft,
                                freeSpinsGameName
                            }) as string}
                        </BonusText>
                    </Container>
                </SnackbarContent>
            </ClickAwayListener>
        )
    }

    return null;
});

export default BonusSnackbar;